export default __webpack_public_path__ + "static/media/risk-icon.38b28f90.svg";